import React from 'react';
import styled from 'styled-components';
import { IconBase } from '../Base';
const Wrapper = styled.div `
  position: relative;
`;
export const IconScanCheck = (props) => {
    return (React.createElement(Wrapper, null,
        React.createElement(IconBase, { ...props, viewportSize: 32 },
            React.createElement("path", { d: "M26 11H6V21H26V11Z", stroke: "#A9ACB6", strokeWidth: "1.5", strokeMiterlimit: "10" }),
            React.createElement("g", { className: "scan-data" },
                React.createElement("path", { d: "M14.5 17H9.5", stroke: "#A9ACB6", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }),
                React.createElement("path", { d: "M23.5 15H19.5", stroke: "#A9ACB6", strokeWidth: "1.5", strokeMiterlimit: "10" })),
            React.createElement("g", { className: "scan-light-container" },
                React.createElement("path", { d: "M3 2L15.25 6V26L3 30V2Z", fill: "url(#paint0_linear_5113_44694)", className: "scan-light" }),
                React.createElement("path", { d: "M16.75 26H15.25L15.25 6H16.75V26Z", fill: "#A9ACB6", className: "scan-line" })),
            React.createElement("defs", null,
                React.createElement("linearGradient", { id: "paint0_linear_5113_44694", x1: "3", y1: "16", x2: "15", y2: "16", gradientUnits: "userSpaceOnUse" },
                    React.createElement("stop", { stopColor: "#A9ACB6", stopOpacity: "0" }),
                    React.createElement("stop", { offset: "1", stopColor: "#A9ACB6", stopOpacity: "0.5" })),
                React.createElement("clipPath", { id: "scanDataClip" },
                    React.createElement("rect", { className: "scan-data-clip", x: "0", y: "0", width: "32", height: "32" }))))));
};
//# sourceMappingURL=ScanCheck.js.map